import React from 'react'
import {Link,withRouter} from "react-router-dom";
const currentTab = (history, path) => {
    if (history.location.pathname === path) {
      return { color: "#FFFF00" };
    }

    else {
      return { color: "#FFFFFF" };
    }
  };

  const activateTabReports = (history, path) => {
    if (history.location.pathname === "/admin/pendingadmissions") {
      return { color: "#FFFF00" };
    }
     
    else {
      return { color: "#FFFFFF" };
    }
  };
const MenuAdmin = ({ history }) => 
    (
     
        <nav className="navbar navbar-expand-lg" style={{backgroundColor:"#343a40"}}>
           
           <Link className="navbar-brand" to="/admin/dashboard">S.P.S College of Education Sangli</Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active">
            <Link style={currentTab(history,"/admin/dashboard")} className="nav-link" to="/admin/dashboard">Dashboard <span className="sr-only">(current)</span></Link>
            </li>
           
          
          </ul>
         
          <form className="form-inline my-2 my-lg-0">
          <ul className="navbar-nav mr-auto">
          <li className="nav-item">
          <Link className="nav-link" to="/">Logout</Link>
            </li>
            </ul>
          </form>
        </div>
      </nav>
    
      
    )

export default withRouter(MenuAdmin);